module.exports = __webpack_public_path__ + "2876c12eeb827ccebb6329a97340dbeb.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/6_column_large_x1/public/games/sm_image_2_0.png
// module id = 476
// module chunks = 0